export enum MethodType {
  EVERY = 'every',
  SOME = 'some',
  FILTER = 'filter',
  MISMATCH = 'mismatch'
}
